








































import { Component, Prop, Watch } from 'vue-property-decorator';
import jwtDecode from 'jwt-decode';

import APIService from '@/api';
import { getParentRoute } from '@/router';

import ArrowDownIcon from '@/components/icons/Arrow.vue';
import CloseIcon from '@/components/icons/Close.vue';
import TopBarMenu from '@/componentsV2/atoms/TopBarMenu/TopBarMenu.vue';
import NameIcon from '@/componentsV2/atoms/NameIcon/NameIcon.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { isRootUser } from '@/utils/auth';
import eventBus from '@/utils/eventBus';

import AuthMenuItem from './AuthMenuItem.vue';
import AuthMenuDropdown from './AuthMenuDropdown.vue';

@Component({
  components: {
    AuthMenuItem,
    NameIcon,
    AuthMenuDropdown,
    Typography,
    ArrowDownIcon,
    CloseIcon
  }
})
export default class AuthMenu extends TopBarMenu {
  @Prop() notificationMenu?: any;

  user: any = null;
  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isNotification() {
    return !!this.notificationMenu.length;
  }

  get tokenSuperAdminMail() {
    const token = localStorage.getItem(
      `${window.location.host}-${APIService.SUPER_ADMIN}`
    );

    return jwtDecode(token).extraInfo.mail;
  }

  get actived() {
    const parentRoute = getParentRoute();

    return (
      parentRoute.meta.$group && parentRoute.meta.$group.id === 'auth-menu'
    );
  }

  clickMenu() {
    this.opened = !this.opened;
  }

  toggleAuthTopBarMobile(value: boolean) {
    this.opened = value;
  }

  @Watch('businessInfo')
  getUser() {
    this.user = this.businessInfo ? this.businessInfo.loggedInManager : null;
  }

  created() {
    if (isRootUser()) {
      this.user = {
        fullname: 'Super Admin',
        mail: this.tokenSuperAdminMail
      };
    } else {
      this.getUser();
    }
    eventBus.$on('toggleAuthTopBarMobile', this.toggleAuthTopBarMobile);
  }

  beforeDestroy() {
    eventBus.$off('toggleAuthTopBarMobile', this.toggleAuthTopBarMobile);
  }

  @Watch('opened')
  changedOpened() {
    if (!this.opened) {
      eventBus.$emit('clearNotificationMenu');
      eventBus.$emit('enableScroll');
    } else {
      eventBus.$emit('disableScroll');
    }
  }
}
